import React, { lazy, Suspense } from 'react';
import { Outlet } from 'react-router-dom';
import { NavConfig } from '../../data/constants/nav';

const ProPlayerProfileHistory = lazy(
  () => import('../profiles/proplayer/ProPlayerProfileHistory')
);
const ProPlayerContractHistory = lazy(
  () => import('../profiles/proplayer/ProPlayerContractHistory')
);
const ProPlayerProfileSummaryInfo = lazy(
  () => import('../profiles/proplayer/ProPlayerProfileSummaryInfo')
);

const ProfileMain = lazy(() => import('../profiles/ProfileMain'));

const IntAmateurContractHistory = lazy(
  () => import('../profiles/intamateurplayer/IntAmateurContractHistory')
);
const IntAmateurInfo = lazy(
  () => import('../profiles/intamateurplayer/IntAmateurInfo')
);
const IntAmaProfileSummary = lazy(
  () => import('../profiles/intamateurplayer/IntAmaProfileSummary')
);

const ProPlayerInternational = lazy(
  () => import('../profiles/proplayer/international/ProPlayerInternational')
);

const ProPlayerInfo = lazy(
  () => import('../profiles/proplayer/info/ProPlayerInfo')
);

const ProWaiversTransactions = lazy(
  () =>
    import('../profiles/proplayer/waiverstransactions/ProWaiversTransactions')
);

const ProPlayerService = lazy(
  () => import('../profiles/proplayer/service/ProPlayerService')
);

const ProPlayerDraftAndScouting = lazy(
  () => import('../profiles/proplayer/draft-info/ProPlayerDraftInfo')
);

const ProPlayerStats = lazy(
  () => import('../profiles/proplayer/stats/ProPlayerStats')
);

const ProfileCsp = lazy(() => import('../profiles/csp/ProfileCsp'));

const CSPInvoice = lazy(
  () => import('../profiles/csp/components/invoice/CSPInvoice')
);

const CSPCredit = lazy(
  () => import('../profiles/csp/components/credit/CSPCredit')
);

export default [
  {
    id: NavConfig.groupConfigs.PROFILE.id,
    path: NavConfig.groupConfigs.PROFILE.to,
    element: (
      <ProfileMain>
        <Suspense>
          <Outlet />
        </Suspense>
      </ProfileMain>
    ),
    children: [
      {
        id: NavConfig.linkConfigs.PROFILE_PRO_HISTORY.id,
        path: NavConfig.linkConfigs.PROFILE_PRO_HISTORY.to,
        element: <ProPlayerProfileHistory />,
      },
      {
        id: NavConfig.linkConfigs.PROFILE_PRO_SUMMARY.id,
        path: NavConfig.linkConfigs.PROFILE_PRO_SUMMARY.to,
        element: <ProPlayerProfileSummaryInfo />,
      },
      {
        id: NavConfig.linkConfigs.PROFILE_EMP_HISTORY.id,
        path: NavConfig.linkConfigs.PROFILE_EMP_HISTORY.to,
        element: <ProPlayerProfileHistory />,
      },
      {
        id: NavConfig.linkConfigs.PROFILE_PRO_INFO.id,
        path: NavConfig.linkConfigs.PROFILE_PRO_INFO.to,
        element: <ProPlayerInfo />,
      },
      {
        id: NavConfig.linkConfigs.PROFILE_WV_AND_TX.id,
        path: NavConfig.linkConfigs.PROFILE_WV_AND_TX.to,
        element: <ProWaiversTransactions />,
      },
      {
        id: NavConfig.linkConfigs.PROFILE_PRO_CONTRACTS.id,
        path: NavConfig.linkConfigs.PROFILE_PRO_CONTRACTS.to,
        element: <ProPlayerContractHistory />,
      },
      {
        id: NavConfig.linkConfigs.PROFILE_EMP_CONTRACTS.id,
        path: NavConfig.linkConfigs.PROFILE_EMP_CONTRACTS.to,
        element: <ProPlayerContractHistory />,
      },
      {
        id: NavConfig.linkConfigs.PROFILE_INT_AMA_CONTRACTS.id,
        path: NavConfig.linkConfigs.PROFILE_INT_AMA_CONTRACTS.to,
        element: <IntAmateurContractHistory />,
      },
      {
        id: NavConfig.linkConfigs.PROFILE_INT_AMA_CONTRACTS_AND_INV.id,
        path: NavConfig.linkConfigs.PROFILE_INT_AMA_CONTRACTS_AND_INV.to,
        element: <IntAmateurContractHistory />,
      },
      {
        id: NavConfig.linkConfigs.PROFILE_PRO_INTERNATIONAL.id,
        path: NavConfig.linkConfigs.PROFILE_PRO_INTERNATIONAL.to,
        element: <ProPlayerInternational />,
      },
      {
        id: NavConfig.linkConfigs.PROFILE_INT_AMA_INFO.id,
        path: NavConfig.linkConfigs.PROFILE_INT_AMA_INFO.to,
        element: <IntAmateurInfo />,
      },
      {
        id: NavConfig.linkConfigs.PROFILE_INT_AMA_SUMMARY.id,
        path: NavConfig.linkConfigs.PROFILE_INT_AMA_SUMMARY.to,
        element: <IntAmaProfileSummary />,
      },
      {
        id: NavConfig.linkConfigs.PROFILE_SERVICE.id,
        path: NavConfig.linkConfigs.PROFILE_SERVICE.to,
        element: <ProPlayerService />,
      },
      {
        id: NavConfig.linkConfigs.PROFILE_DRAFT_AND_SCOUTING.id,
        path: NavConfig.linkConfigs.PROFILE_DRAFT_AND_SCOUTING.to,
        element: <ProPlayerDraftAndScouting />,
      },
      {
        id: NavConfig.linkConfigs.PROFILE_STATS.id,
        path: NavConfig.linkConfigs.PROFILE_STATS.to,
        element: <ProPlayerStats />,
      },
      {
        id: NavConfig.linkConfigs.CSP.id,
        path: NavConfig.linkConfigs.CSP.to,
        element: <ProfileCsp />,
      },
    ],
  },
  {
    id: NavConfig.linkConfigs.CSP_INVOICE.id,
    path: NavConfig.linkConfigs.CSP_INVOICE.to,
    element: <CSPInvoice />,
  },
  {
    id: NavConfig.linkConfigs.CSP_CREDIT.id,
    path: NavConfig.linkConfigs.CSP_CREDIT.to,
    element: <CSPCredit />,
  },
];
